<template>
  <v-app>
    <router-view></router-view>
    <!-- <v-snackbar v-model="sb" top right>
      HOLA
      <v-spacer />
      <v-btn color="white" text @click="sb = false">Close</v-btn>
    </v-snackbar>-->
  </v-app>
</template>

<script>
  // import qs from "qs";
  // import axios from "axios";
  // import { mapGetters } from "vuex";
  import "typeface-roboto";
  import "@mdi/font/css/materialdesignicons.css";
  import "material-design-icons-iconfont/dist/material-design-icons.css";
  // import HelloWorld from "./components/HelloWorld";
  // import Login from "./components/Login";

  let verificaToken;

  export default {
    name: "App"
    // computed: {
    //   ...mapGetters(["getToken"])
    // },
    // beforeCreate() {
    //   console.log(this.getToken);
    //   // verificaToken = axios.
    // }
  };
</script>
